import { ERROR_MESSAGES } from 'shared'
import { toast } from 'sonner'
import { ApiError } from '@/lib'

function isInquiryCompletedError(error: Error): boolean {
  return (
    error instanceof ApiError && error.status === 400 && error.message === ERROR_MESSAGES.INQUIRY_COMPLETED_CONSTRAINT
  )
}

function showInquiryCompletedToast(): void {
  toast.warning('他のユーザーが編集しました。', {
    description: '画面を再読み込みしてください',
    action: { label: '再読み込み', onClick: () => window.location.reload() },
  })
}

export function notifyMutationError(error: Error, failureMessage: string): void {
  if (isInquiryCompletedError(error)) {
    showInquiryCompletedToast()
  } else {
    toast.error(`${failureMessage}: ${error.message}`)
  }
}
